import { createAction } from '@reduxjs/toolkit';

export const getStartedPageRequest = createAction('GET_STARTED_REQUEST', data => {
    return { payload: data }
});

export const getStartedPageSuccess = createAction('GET_STARTED_SUCCESS', response => {
    return { payload: response }
});

export const getStartedPageFailure = createAction('GET_STARTED_FAILURE', error => {
    return { payload: error }
});

export const getStartedPageReset = createAction('GET_STARTED_RESET', error => {
    return { payload: error }
});